import formatUTCDate from '@/shared/tools/formatUTCDate'
import useGasMeter from '@/containers/SubscriptionFormPageNew/Components/GasMeter/useGasMeter'
import SDNotification from '@/shared/components/SDComponentsNewDesign/SDNotification/SDNotification'
import { getAuthorizationText } from '@/shared/utils/meterAuthorizationUtils'
import IconLockOpen from '@/shared/icons/NewDesign/IconLockOpen'
import SDButton from '@/shared/components/SDComponentsNewDesign/SDButton/SDButton'

const MeterConsent = () => {
  const { t, canRequestMeterData, isValidPce, meterConsent, consentDate, requestPceEligibility, gasMeterUpdate } =
    useGasMeter({ type: 'client' })

  if (!canRequestMeterData) {
    return null
  }

  const primaryTextForAuthorization = getAuthorizationText(t, 'cdf', 'gas')
  const primaryTextForAutorized = `${t('subscriptionForm:pce_module.meter_authorization.authorized_v2')} ${
    new Date(consentDate)
      .toLocaleString('fr-FR')
      .replace(/ /g, ` ${t('subscriptionForm:pce_module.meter_authorization.consent_date_separator')} `) // replace normal spaces with non-breaking spaces
  }`

  return (
    <>
      <SDNotification type='info' hidden={meterConsent} primaryText={primaryTextForAuthorization} border>
        <SDButton
          overrides={{
            BaseButton: {
              style: () => ({
                gap: '0.25rem',
              }),
            },
          }}
          block
          disabled={meterConsent || !isValidPce || !canRequestMeterData}
          onClick={() => {
            gasMeterUpdate({
              meterConsent: true,
              consentDate: formatUTCDate(new Date().toISOString().slice(0, 19)),
            })

            requestPceEligibility()
          }}
        >
          <IconLockOpen color='white' />
          {t('subscriptionForm:pdl_module.enedis_authorization.authorize_yes')}
        </SDButton>
      </SDNotification>

      <SDNotification type='positive' hidden={!meterConsent} primaryText={primaryTextForAutorized} />
    </>
  )
}

export default MeterConsent
